export enum ParrotStages {
    PRELOADER = 0,
    MAIN_GAME = 1,
    MAIN_UNLOADABLE = 2
}

export enum ParrotPrompts {
    ADD_FREESPINS = "addfreespins"
}

export const CANVAS_SIZES = {
    DEFAULT_PORTRAIT_SCALE: 1/0.76,
    GAMEINTRO_PORTRAIT_SCALE: 1.7,
    FREESPINS_PORTRAIT_SCALE: 1/0.86
};
